import { useState, useRef, useEffect } from 'react';
import { Container, Row, Col, Form, Button, InputGroup } from 'react-bootstrap';
import axios from 'axios';

import MSearchResults from './msearchresults';

function MHome(props) {
    const mSearchResultsRef = useRef(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [searchTable, setSearchTable] = useState('');
    const [searchSQL, setSearchSQL] = useState('');
    const [llmResponse, setLlmResponse] = useState({});

    const [debugMode, setDebugMode] = useState(false);
    const [updatingRowData, setUpdatingRowData] = useState(false);
    const passUpdatingRowData = (data) => (setUpdatingRowData(data));
    const [leadsResultsCount, setLeadsResultsCount] = useState(0);
    const passLeadsResultsCount = (data) => { setLeadsResultsCount(data) };
    const [fetchingLlmResponse, setFetchingLlmResponse] = useState(false);
    const [sqlExecutionStatus, setSqlExecutionStatus] = useState('');
    const passSqlExecutionStatus = (data) => { setSqlExecutionStatus(data) };
    const [showLeadsGridView, setShowLeadsGridView] = useState(true);
    const [forceLeadsRefresh, setForceLeadsRefresh] = useState(false);
    
    useEffect(() => {
        mSearchResultsRef.current?.toggleView(!showLeadsGridView);
    }, [showLeadsGridView]);

    const toggleLeadsView = () => {
        setShowLeadsGridView(!showLeadsGridView)
    }

    const tabRefresh = () => {
        setForceLeadsRefresh(!forceLeadsRefresh)
    }
    
    async function askLLM() {
        if (searchQuery.length <= 0) {
            setSearchSQL('');
            setUpdatingRowData(false);
            setLeadsResultsCount(0);
            return;
        }

        setFetchingLlmResponse(true);
        setSearchSQL('');
        try {
            const response = await axios.post('/getmegallmresults', {searchQuery});
            const llmResult = response.data;
            
            setLlmResponse(llmResult.data);
            if (llmResult.sql === '') {
                setSearchSQL('No results found. Please refine your query.')    
            } else {
                setSearchSQL(llmResult.sql);
                setSearchTable(llmResult.table);
            }
            setFetchingLlmResponse(false);
        } catch (e) {
            console.log(e);
            setLlmResponse(e);
            setFetchingLlmResponse(false);
            setSearchSQL('No results found. Please refine your query.')
        }
    }
    
    function handleSearchQueryChange(e) {
        const eQuery = e.target.value;
        setSearchQuery(eQuery);
    }

    function startSearch(event) {
        event.preventDefault();
        event.stopPropagation();

        setUpdatingRowData(true);
        askLLM(searchQuery);
    }

    useEffect(() => {
        if (searchSQL && searchSQL.length > 0 && mSearchResultsRef.current) {
            mSearchResultsRef.current.fetchData();
        }
    }, [searchSQL, forceLeadsRefresh])

    return (
    <div className="bg-dark text-white d-flex flex-column justify-content-center align-items-center" style={{height: "calc(100% + 4px)"}}>
      <Container className='h-100 d-flex flex-column'>
        <Row className="justify-content-center text-center mt-4 mb-2">
          <Col md={8} lg={6}>
            <h1 className="fw-semibold">Ask. Discover. Outreach.</h1>
            <p className="text-white">Search across 50M+ businesses and people instantly</p>
          </Col>
        </Row>

        <Row className="justify-content-center mb-2">
          <Col md={10} lg={8}>
            <Form onSubmit={startSearch}>
                <InputGroup size="lg">
                <Form.Control
                    placeholder="Ask something..."
                    className="bg-secondary text-white border-0"
                    value={searchQuery}
                    onChange={handleSearchQueryChange}
                    type="search"
                />
                <Button variant={`${debugMode ? 'light' : 'primary'}`} onClick={startSearch} onContextMenu={() => setDebugMode(!debugMode)}>
                    {fetchingLlmResponse || updatingRowData ? (<i className="fa fa-spinner fa-pulse" />) : <i className="bi bi-send" />}
                </Button>
                </InputGroup>
            </Form>
          </Col>
        </Row>

        {debugMode ? 
        <div className='mb-2 m-0 p-0 w-100 d-flex flex-column text-center'>
            <div>{fetchingLlmResponse ? 'Thinking...' : <>{JSON.stringify(llmResponse)}</>}</div>
        </div>
        : ''}
        {debugMode ?
        <div className='mb-2 m-0 p-0 w-100 d-flex flex-column text-center'>
            {fetchingLlmResponse ? <>Thinking...</> :
             updatingRowData ? <>Generating...</> :
             <>{searchTable} | {searchSQL} | {sqlExecutionStatus}</>
            }
        </div>
        : ''}
        <div className={`mb-0 m-0 p-0 w-100 d-flex flex-row align-items-center ${(leadsResultsCount > 0) ? 'visible' : 'invisible'}`}>
            <div className={`${debugMode ? 'd-none' : 'd-flex'} flex-grow-1`}><span className='mx-auto'>{fetchingLlmResponse ? 'Thinking...' : updatingRowData ? 'Generating...' : ''}</span></div>
            <div className='ms-auto'>
                <Button className={`me-1`} variant="outline-light">{fetchingLlmResponse || updatingRowData ? (<i className="fa fa-spinner fa-pulse" />) : `Found ${parseInt(leadsResultsCount).toLocaleString()} Leads`}</Button>
                <Button title="Grid / Cards" className={`me-1 float-right`} onClick={toggleLeadsView}><i className={`bi ${showLeadsGridView ? 'bi-list' : 'bi-grid'}`}></i></Button>
                <Button title="Refresh" className={`me-1 float-right`} onClick={tabRefresh}><i className={`bi bi-arrow-repeat`}></i></Button>
            </div>
        </div>

        <div className={`m-0 p-0 w-100 ${(leadsResultsCount > 0) ? 'd-flex flex-row flex-grow-1' : 'd-none'}`}>
            <div className={`m-0 p-0 w-100 d-flex`}>
                <MSearchResults ref={mSearchResultsRef} mode={searchTable} loggedInUserPlan={props.plan} loggedInUserId={props.uid} loggedInPlanId={props.plid} searchQuery={searchSQL} seu={passSqlExecutionStatus} rcu={passLeadsResultsCount} urd={passUpdatingRowData} />
            </div>
        </div>

        <div className={`m-0 p-0 w-100 ${(updatingRowData || (searchSQL.length <= 0) || (leadsResultsCount > 0)) ? 'd-none' : 'd-flex flex-row flex-grow-1'}`}>
            <span className='mx-auto'>Could not find any results. Please try again.</span>
        </div>
      </Container>
    </div>    )
}

export default MHome;